import { View } from '@react-pdf/renderer'

import { Field, Objectclass, YesObject } from '@yes.technology/react-toolkit'

import { RelationsTableLayouts } from 'report/hooks/useRelationsTableLayouts/useRelationsTableLayouts'

import { FieldSettings } from 'shared/types'
import { ConcatFields } from 'shared/utils/object/concatenateFields'

import { RelationConfigProps } from 'site/Renderer/components/ObjectView/components/types/object-view'

import PDFAreaLine from '../PDFAreaLine'

import ObjectCard from './components/ObjectCard/ObjectCard'

interface CardsAreaProps {
  title: string
  objectclass: Objectclass
  objects: YesObject[]
  fields: Field[]
  relationClasses: Field[]
  relationsTableLayouts?: RelationsTableLayouts
  fieldSettings?: FieldSettings
  concatFields?: ConcatFields
  relationConfig?: RelationConfigProps
  showHeader?: boolean
}

function CardsArea({
  showHeader,
  objectclass,
  fields,
  title,
  objects,
  relationClasses,
  relationsTableLayouts,
  concatFields,
  relationConfig
}: CardsAreaProps) {
  return (
    <View>
      {showHeader && <PDFAreaLine title={objectclass.des} />}

      {objects?.map((object) => (
        <ObjectCard
          key={object.uuid}
          fields={fields}
          object={object}
          relationClasses={relationClasses}
          title={title}
          relationsTableLayouts={relationsTableLayouts}
          concatFields={concatFields}
          relationConfig={relationConfig}
        />
      ))}
    </View>
  )
}

export default CardsArea
